// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { MinecraftFilterClauseSet } from "./MinecraftFilterClauseSet";

export default interface MinecraftFilter extends MinecraftFilterClauseSet {}
